import { Wind, Square, Turtle, Trophy, Heart, Moon, CircleDot, Leaf, Crown, Smartphone, GitBranch, Flame, Snowflake, Zap } from 'lucide-react';

const GuidedModeContent = ({
  patterns,
  setSelectedPattern,
  setShowButeykoModal,
  setShowBoxBreathingModal,
  setShowCoherenceModal,
  setShow478Modal,
  setShowPursedLipModal,
  setShowCalmingModal,
  setShowRussianMastersModal,
  setShowReduceFrequencyModal,
  setShowHapticBreathingModal,
  setShowAlternateNostrilModal,
  setShowBellowsBreathModal,
  setShowWimHofModal,
  setShowExtremeModal,
  setChallengeMode
}) => {
  
  // Categories with their exercises
  const categories = [
    {
      id: 'co2',
      title: 'Désensibilisation au CO2',
      description: 'Augmentez votre tolérance au CO2 pour réduire l\'essoufflement',
      accentColor: 'from-sky-400 to-cyan-500',
      glowAccent: '56, 189, 248',
      exercises: [
        {
          id: 'petites-pauses',
          name: 'Petites apnées répétées',
          icon: Wind,
          color: 'from-sky-400 to-cyan-500',
          glowColor: '56, 189, 248',
          delay: 0,
          onClick: () => {
            const pattern = patterns.find(p => p.name.toLowerCase().includes('buteyko') || p.name.toLowerCase().includes('petites pauses'));
            if (pattern) {
              setSelectedPattern(pattern);
              setShowButeykoModal(true);
            }
          }
        },
        {
          id: 'respiration-carree',
          name: 'Respiration Carrée',
          icon: Square,
          color: 'from-teal-400 to-emerald-500',
          glowColor: '45, 212, 191',
          delay: 0.3,
          onClick: () => {
            const pattern = patterns.find(p => p.name.toLowerCase().includes('carrée') || p.name.toLowerCase().includes('box'));
            if (pattern) {
              setSelectedPattern(pattern);
              setShowBoxBreathingModal(true);
            }
          }
        },
        {
          id: 'reduire-frequence',
          name: 'Respiration Réduite (Diminuer sa Fréquence Respiratoire)',
          icon: Turtle,
          color: 'from-green-400 to-lime-500',
          glowColor: '74, 222, 128',
          delay: 0.6,
          onClick: () => setShowReduceFrequencyModal(true)
        },
        {
          id: 'narines-alternees',
          name: 'Narines Alternées',
          icon: GitBranch,
          color: 'from-violet-400 to-purple-500',
          glowColor: '167, 139, 250',
          delay: 0.9,
          onClick: () => setShowAlternateNostrilModal(true)
        },
        {
          id: 'defis',
          name: 'Défis',
          icon: Trophy,
          color: 'from-amber-400 to-yellow-500',
          glowColor: '251, 191, 36',
          delay: 1.2,
          onClick: () => setChallengeMode(true)
        }
      ]
    },
    {
      id: 'vagus',
      title: 'Calmante (Nerf Vague)',
      description: 'Activez votre système parasympathique pour vous détendre',
      accentColor: 'from-rose-400 to-pink-500',
      glowAccent: '251, 113, 133',
      exercises: [
        {
          id: 'coherence',
          name: 'Cohérence Cardiaque',
          icon: Heart,
          color: 'from-rose-400 to-pink-500',
          glowColor: '251, 113, 133',
          delay: 0,
          onClick: () => {
            const pattern = patterns.find(p => 
              p.name.toLowerCase().includes('cohéren') || 
              p.name.toLowerCase().includes('coheren')
            );
            if (pattern) {
              setSelectedPattern(pattern);
              setShowCoherenceModal(true);
            } else {
              setShowCoherenceModal(true);
            }
          }
        },
        {
          id: '478',
          name: 'Technique 4-7-8',
          icon: Moon,
          color: 'from-indigo-400 to-violet-500',
          glowColor: '129, 140, 248',
          delay: 0.3,
          onClick: () => {
            const pattern = patterns.find(p => p.name.toLowerCase().includes('4-7-8') || p.name.toLowerCase().includes('478'));
            if (pattern) {
              setSelectedPattern(pattern);
              setShow478Modal(true);
            }
          }
        },
        {
          id: 'levres-pincees',
          name: 'Focus sur la capacité à expirer : Allongement du temps expiratoire',
          icon: CircleDot,
          color: 'from-fuchsia-400 to-purple-500',
          glowColor: '232, 121, 249',
          delay: 0.6,
          onClick: () => {
            const pattern = patterns.find(p => p.name.toLowerCase().includes('lèvres') || p.name.toLowerCase().includes('pursed'));
            if (pattern) {
              setSelectedPattern(pattern);
              setShowPursedLipModal(true);
            }
          }
        },
        {
          id: 'calmante',
          name: 'Respiration Calmante',
          icon: Leaf,
          color: 'from-emerald-400 to-teal-500',
          glowColor: '52, 211, 153',
          delay: 0.9,
          onClick: () => {
            const pattern = patterns.find(p => p.name.toLowerCase().includes('calmante') || p.name.toLowerCase().includes('calming'));
            if (pattern) {
              setSelectedPattern(pattern);
              setShowCalmingModal(true);
            }
          }
        }
      ]
    },
    {
      id: 'mastery',
      title: 'Maîtrise',
      description: 'Exercices avancés pour un contrôle complet de votre respiration',
      accentColor: 'from-orange-400 to-red-500',
      glowAccent: '251, 146, 60',
      exercises: [
        {
          id: 'russian',
          name: 'Maîtres Russes',
          icon: Crown,
          color: 'from-orange-400 to-red-500',
          glowColor: '251, 146, 60',
          delay: 0,
          onClick: () => setShowRussianMastersModal(true)
        },
        {
          id: 'haptic',
          name: 'Respiration Haptique',
          subtitle: 'Mobile',
          icon: Smartphone,
          color: 'from-blue-400 to-indigo-500',
          glowColor: '96, 165, 250',
          delay: 0.3,
          onClick: () => setShowHapticBreathingModal(true)
        },
        {
          id: 'soufflet',
          name: 'Crâne qui brille',
          icon: Flame,
          color: 'from-amber-400 to-orange-500',
          glowColor: '251, 191, 36',
          delay: 0.6,
          onClick: () => setShowBellowsBreathModal(true)
        },
        {
          id: 'wim-hof',
          name: 'Wim Hof',
          icon: Snowflake,
          color: 'from-cyan-400 to-blue-500',
          glowColor: '34, 211, 238',
          delay: 0.9,
          onClick: () => setShowWimHofModal(true)
        },
        {
          id: 'extreme',
          name: 'Extrême',
          icon: Zap,
          color: 'from-orange-500 to-red-600',
          glowColor: '249, 115, 22',
          delay: 1.2,
          onClick: () => setShowExtremeModal(true)
        }
      ]
    }
  ];

  return (
    <div className="mb-4 sm:mb-8 space-y-10">
      <style>{`
        @keyframes breathe {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.09);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
        
        @keyframes glowPulse {
          0%, 100% {
            box-shadow: 0 0 30px rgba(var(--glow-color), 0.3),
                        0 0 60px rgba(var(--glow-color), 0.1),
                        inset 0 0 30px rgba(var(--glow-color), 0.2);
          }
          50% {
            box-shadow: 0 0 50px rgba(var(--glow-color), 0.5),
                        0 0 100px rgba(var(--glow-color), 0.2),
                        inset 0 0 50px rgba(var(--glow-color), 0.3);
          }
        }

        .breathing-circle {
          animation: breathe 5s ease-in-out infinite, glowPulse 5s ease-in-out infinite;
        }
        
        .breathing-circle:hover {
          animation-play-state: paused;
          transform: scale(1.1);
        }
      `}</style>
      
      {categories.map((category, catIndex) => (
        <div key={category.id}>
          {/* Category Header */}
          <div className="mb-6 text-center">
            <div 
              className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full mb-2"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.15)'
              }}
            >
              <div 
                className={`w-3 h-3 rounded-full bg-gradient-to-r ${category.accentColor}`}
                style={{ boxShadow: `0 0 12px rgba(${category.glowAccent}, 0.6)` }}
              />
              <span 
                className="text-lg sm:text-xl font-semibold text-slate-900"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {category.title}
              </span>
            </div>
            <p className="text-slate-700 text-sm">
              {category.description}
            </p>
          </div>
          
          {/* Floating Circles */}
          <div className="flex flex-wrap justify-center gap-6 sm:gap-8 lg:gap-12">
            {category.exercises.map((exercise) => (
              <button
                key={exercise.id}
                onClick={exercise.onClick}
                className="group flex flex-col items-center focus:outline-none"
                data-testid={`exercise-${exercise.id}`}
              >
                {/* Floating Glassmorphism Circle */}
                <div 
                  className="breathing-circle relative w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 rounded-full flex items-center justify-center cursor-pointer transition-all duration-500 group-hover:scale-110"
                  style={{
                    '--glow-color': exercise.glowColor,
                    background: `linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)`,
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    animationDelay: `${exercise.delay + catIndex * 0.5}s`
                  }}
                >
                  {/* Gradient color overlay — full opacity for vivid colors on light background */}
                  <div 
                    className={`absolute inset-0 rounded-full bg-gradient-to-br ${exercise.color}`}
                  />
                  
                  {/* Inner highlight */}
                  <div 
                    className="absolute inset-2 rounded-full"
                    style={{
                      background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%)',
                      border: '1px solid rgba(255,255,255,0.1)'
                    }}
                  />
                  
                  {/* Icon */}
                  <exercise.icon 
                    className="relative z-10 w-10 h-10 sm:w-12 sm:h-12 text-white drop-shadow-lg transition-transform duration-300 group-hover:scale-110" 
                    strokeWidth={1.5} 
                  />
                </div>

                {/* Title */}
                <span 
                  className="mt-3 text-xs sm:text-sm font-medium text-slate-900 text-center max-w-[100px] sm:max-w-[120px] transition-colors group-hover:text-sky-700"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {exercise.name}
                </span>
                
                {/* Subtitle if exists */}
                {exercise.subtitle && (
                  <span className="text-[10px] text-slate-600 mt-0.5">
                    {exercise.subtitle}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GuidedModeContent;
